module.exports = __webpack_public_path__ + "static/media/showroomNewKTM.f5246d3b.svg";